module.exports = __webpack_public_path__ + "media/images/lb/257-8db217bbd18a467384343736239ebd7d.svg";